// extracted by mini-css-extract-plugin
export default {"isReadOnly":"ClickableMedicalReactionItem_isReadOnly__xKDJW"};